import { AdobeTargetResponsePersonalizationPayload } from '@/models/adobe-target';
import { AnalyticsEvent } from '../models';

export class PropositionDisplayEvent implements AnalyticsEvent {
  name = 'PropositionDisplayEvent';
  constructor(public readonly targetResponsePayloads: AdobeTargetResponsePersonalizationPayload[]) {}
}